// extracted by mini-css-extract-plugin
var _1 = "top-XAxea";
export { _1 as "top" }
